// Chart.js plugin that hatches the x-axis slots of excluded (outage) days, so
// a chart keeps those days on its axis but visibly out of play. Pass the
// excluded category indices as `options.plugins.excludedDays.indices`
// (and `dark: true` in dark mode); register it per chart via `plugins`.

const STRIPE_LIGHT = 'rgba(100, 116, 139, 0.30)'; // slate-500, as the CSS hatch
const STRIPE_DARK = 'rgba(148, 163, 184, 0.30)'; // slate-400

// An 8px tile with one diagonal stripe, repeated as the band's fill.
function hatchPattern(ctx, dark) {
  const tile = document.createElement('canvas');
  tile.width = 8;
  tile.height = 8;
  const stripe = tile.getContext('2d');
  stripe.strokeStyle = dark ? STRIPE_DARK : STRIPE_LIGHT;
  stripe.lineWidth = 2;
  stripe.beginPath();
  stripe.moveTo(-2, 10);
  stripe.lineTo(10, -2);
  stripe.stroke();
  return ctx.createPattern(tile, 'repeat');
}

const excludedDaysPlugin = {
  id: 'excludedDays',

  beforeDatasetsDraw(chart, _args, options) {
    const indices = options?.indices || [];
    if (!indices.length) return;
    const {ctx, chartArea, scales} = chart;
    const pixelOf = (i) => scales.x.getPixelForValue(i);
    // Each category owns the space halfway to its neighbours.
    const halfSlot = chart.data.labels.length > 1
      ? Math.abs(pixelOf(1) - pixelOf(0)) / 2
      : (chartArea.right - chartArea.left) / 2;

    ctx.save();
    ctx.fillStyle = hatchPattern(ctx, options.dark);
    indices.forEach((i) => {
      const left = Math.max(chartArea.left, pixelOf(i) - halfSlot);
      const right = Math.min(chartArea.right, pixelOf(i) + halfSlot);
      ctx.fillRect(left, chartArea.top, right - left, chartArea.bottom - chartArea.top);
    });
    ctx.restore();
  },
};

export default excludedDaysPlugin;
